import { ModelFilter } from "react3l-common";

export class UserManualFilter extends ModelFilter {
  public id?: number;
  public search?: string = null;
  public siteId?: number;
  public currentPage?: number;
  public pageSize?: number;
}
